import type { ClassValue } from 'clsx'

import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 格式化日期字符串（包含秒）
 * @param dateString 日期字符串
 * @param locale 区域设置，默认为 'zh-CN'
 * @returns 格式化后的日期字符串
 */
export function formatDateTime(dateString?: string, locale: string = 'zh-CN'): string {
  if (!dateString)
    return '-'
  return new Date(dateString).toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}
